import { Controller } from 'react-hook-form'

import type { MessagePriceSelectorProps } from '@/modules/message/components/editor/fields/message-price-selector'
import { MessageTitleSelector } from '@/modules/message/components/editor/fields/message-title-selector'

type Props = Omit<MessagePriceSelectorProps, 'field'>

export const MessageTitleSelectorController = (props: Props) => {
  return (
    <Controller
      name="title"
      render={({ field, fieldState: { error } }) => (
        <MessageTitleSelector
          {...props}
          field={{ ...field, error }}
        />
      )}
    />
  )
}
